import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {Box, Autocomplete ,Button, TextField, IconButton, MenuItem, RadioGroup, FormControlLabel, Radio, Grid, Card, CardContent, Typography, Grow, Divider ,  Snackbar,Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { fetchToken } from '../../../../Auth';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MuiAlert from "@mui/material/Alert";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const RedirectionForm = ({ mode,data,handleCloseForm }) => {
    const navigate = useNavigate();
    const isEditMode = mode === 'edit';
    
    const [oldUrls, setOldUrls] = useState([]);
    const [type, setType] = useState('blog');
    const [customMappedUrl, setCustomMappedUrl] = useState('');
    const [originalMapped,setOriginalMapped] = useState('')
    const [mappedUrl, setMappedUrl] = useState({
        blog:"",
        caseStudy:"",
        roadAhead:""
    });

    const [predefinedMappings, setPredefinedMappings] = useState({
        blog: [],
        caseStudy: [],
        roadAhead: []
    });
    
    const [toastMessage, setToastMessage] = useState({
        open: false,
        message: "",
        severity: "info",
      });
    

    const getAllCaseStudy = async () => {
        try {
            const response = await axios.get(`/fetch_all_case_studies/noextra`, { 
                headers: {
                    'Content-Type': 'application/json'
                },
            });
    
            if (response.status === 200 && response.data) {
                const caseStudyUrls = response.data.map(item => ({
                    url: item.url,
                    id: item.pageId
                })); 
            
                setPredefinedMappings(prev => ({ ...prev, caseStudy: caseStudyUrls }));
            }
            
        } catch (err) {
            console.error("Error fetching case studies", err);
        }
    };
    
    const getAllBlogs = async () => {
        try {
            const response = await axios.get(`/fetch_all_blogs/noextra`, { 
                headers: {
                    'Content-Type': 'application/json'
                },
            });
    
            if (response.status === 200 && response.data) {
                const blogUrls = response.data.map(item => ({
                    url: item.url,
                    id: item.pageId
                })); 
                setPredefinedMappings(prev => ({ ...prev, blog: blogUrls }));
            }
            
        } catch (err) {
            console.error("Error fetching blogs", err);
        }
    };
    
    const getAllRoadAheadTalks = async () => {
        try {
            const response = await axios.get(`/fetch_webinars`, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
    
            if (response.status === 200 && response.data) {
                const webinarUrls = response.data.map(item => ({
                    url: item.seo?.pageURL,
                    id: item.id
                })); 
            
                setPredefinedMappings(prev => ({ ...prev, roadAhead: webinarUrls }));
            }
            
        } catch (err) {
            console.error("Error fetching road ahead talks", err);
        }
    };
    
    useEffect(() => {
        if (isEditMode) {
            setOriginalMapped({
                type:data.type,
                url:data.mapped_url
            })
            if(data.type == "custom"){
                setCustomMappedUrl(data.mapped_url)
            }
            else{
            setMappedUrl((prev) => ({
                ...prev,
                [data.type]: {url:data.mapped_url,id:data.content_id}
            }));
        }
            setType(data.type);
            setOldUrls(data.oldUrls);
        }
    

        getAllBlogs()
        getAllCaseStudy()
        getAllRoadAheadTalks()
    }, []);


    const handleTypeChange = (event) => {
        const selectedType = event.target.value;
        setType(selectedType);
    };

    const handleAddOldUrl = () => {
        setOldUrls(['', ...oldUrls]);
    };

    const handleRemoveOldUrl = (index) => {
        setOldUrls(oldUrls.filter((_, i) => i !== index));
    };

    const handleOldUrlChange = (index, value) => {
        const updatedUrls = [...oldUrls];
        updatedUrls[index] = value;
        setOldUrls(updatedUrls);
    };

    const handleSubmit = async () => {
        if (!type) {
            toast.error("Please select a type.");
            return;
        }

        if ((type === "blog" || type === "caseStudy" || type === "roadAhead") && !mappedUrl[type]) {
            toast.error(`Please select a Mapped URL for ${type === "blog" ? "Blog" : type === "caseStudy" ? "Case Study" : "Road Ahead Talk"}.`);
            return;
        }
        
        if (type === "custom" && !customMappedUrl) {
            toast.error("Custom Mapped URL cannot be blank.");
            return;
        }
        
        const filteredOldUrls = oldUrls.filter(url => url.trim() !== '');

        if (filteredOldUrls.length === 0) {
            toast.error("At least one valid URL is required.");
            return;
        }
    

        try {
            const payload = {
                oldUrls: filteredOldUrls, 
                mapped_url: type === "custom" ? customMappedUrl : mappedUrl[type]['url'], 
                content_id :type === "custom" ? "custom" : mappedUrl[type]['id'], 
                type: type, 
                mode: mode 
            };
            if (isEditMode) {
                payload.id = data.id; 
            }
            const response = await axios.post(`/backend/save_redirection`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
                },
            });
    
            if (response.status === 200) {
                // navigate(0);
                setToastMessage({
                    open: true,
                    message: "Redirection Updated successfully!",
                    severity: "success",
            });
                setTimeout(() => {
                    handleCloseForm()
                }, 1000);
            }
        } catch (err) {
            console.log(err.response?.data?.msg)
            setToastMessage({
                open: true,
                message: err.response?.data?.msg || "An unexpected error occurred.",
                severity: "error",
        });

            console.error("Error saving redirection", err);
        }
    };
    
    const handleUrlSelection = (value) =>{
        setMappedUrl((prev) => ({
            ...prev,
            [type]: value
        }));
    }

    const [open, setOpen] = useState(false);

    const navigateBack = () => {
        setOpen(true);
    };

    const handleConfirmExit = () => {
        handleCloseForm(); 
        setOpen(false);
    };

    const handleCancel = () => {
        setOpen(false); 
    };
    return (
        <Grow in>


            <Card elevation={3} style={{ padding: '20px', borderRadius: '10px', boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.15)' }}>
            <Dialog open={open} onClose={handleCancel}>
                <DialogTitle>Confirm Exit</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to exit? All unsaved changes will be lost.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmExit} color="error">
                        Exit
                    </Button>
                </DialogActions>
            </Dialog>
            
                <CardContent>
                <Box display="flex" alignItems="center" gap={1} style={{marginBottom:1}}>
                <Button onClick={navigateBack} sx={{ minWidth: "auto", p: 0 }}>
                    <ArrowBackIcon sx={{ fontSize: 24 }} />
                </Button>
                <Typography variant="h5" gutterBottom style={{marginBottom:0}}>
                    {isEditMode ? "Edit" : "Create"} Redirection
                </Typography>
                </Box>
                    <div className='col-12 d-flex justify-content-between'>
                     <div>   
                    <Typography variant="subtitle1">Type</Typography>
                    <RadioGroup row value={type} onChange={handleTypeChange}>
                        <FormControlLabel value="blog" control={<Radio />} label="Blog" />
                        <FormControlLabel value="caseStudy" control={<Radio />} label="Case Study" />
                        <FormControlLabel value="roadAhead" control={<Radio />} label="Road Ahead" />
                        <FormControlLabel value="custom" control={<Radio />} label="Custom" />
                    </RadioGroup>
                    </div>
                    <div className="mt-4">
                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                            {isEditMode ? 'Update' : 'Create'} Redirection
                        </Button>
                    </div>

                    </div>                    
                    <Typography 
                        variant="subtitle1" 
                        sx={{ 
                            marginBottom: '1em', 
                            fontWeight: 'bold', 
                            color: '#333',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                    >
                        Mapped URL {isEditMode && (
                            <>
                                <span style={{ color: '#1976D2' }}>:- {originalMapped.url}</span> 
                                <span style={{ color: '#D32F2F' }}>Type: ({originalMapped.type})</span>
                            </>
                        )}
                    </Typography>


                    {type === 'custom' ? (
                        <TextField
                            label="Mapped URL"
                            fullWidth
                            variant="outlined"
                            value={customMappedUrl}
                            onChange={(e) => setCustomMappedUrl(e.target.value)}
                        />
                    ) : (
                        <Autocomplete
                            options={predefinedMappings[type] || []}
                            value={mappedUrl[type] || null} 
                            getOptionLabel={(option) => option?.url || ""} 
                            onChange={(event, newValue) => handleUrlSelection(newValue)}
                            renderInput={(params) => <TextField {...params} label="Mapped URL" variant="outlined" />}
                        />
                    )}

                    <Divider sx={{ borderBottomWidth: 2, borderColor: 'rgba(0, 0, 0, 0.3)', margin: '16px 0' }} />

                    
                    <Typography variant="subtitle1">Old URLs</Typography>
                    <Button variant="contained" startIcon={<AddIcon />} onClick={handleAddOldUrl}>
                        Add Old URL
                    </Button>
                    <Grid container spacing={2} className="mt-2">
                        {oldUrls.map((url, index) => (
                            <Grid item xs={6} key={index}>
                                <div className="d-flex align-items-center" style={{ display: 'flex', gap: '10px' }}>
                                    <TextField
                                        label="Old URL"
                                        variant="outlined"
                                        value={url}
                                        onChange={(e) => handleOldUrlChange(index, e.target.value)}
                                        fullWidth
                                    />
                                    <IconButton onClick={() => handleRemoveOldUrl(index)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
                <Snackbar
                open={toastMessage.open}
                autoHideDuration={6000}
                onClose={() => setToastMessage((prev) => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <MuiAlert
                elevation={6}
                variant="filled"
                severity={toastMessage.severity}
                onClose={() => setToastMessage((prev) => ({ ...prev, open: false }))}
                >
                {toastMessage.message}
                </MuiAlert>
            </Snackbar>

            </Card>
        {/* Toast Message */}

        </Grow>
        
    );
};

export default RedirectionForm;